module.exports = __webpack_public_path__ + "img/horizontal_4_7_3016.221ffca1.png";